<template>
  <div id="user-edit-tab-info" class="mt-0" style="margin-top: 0px !important;">
    <div id="studentLogbokClassLoadingDiv" class="vs-con-loading__container">
      <div  class="vx-row" >
        <div class="vx-col w-full pt-1" align="right">
          <vs-button v-on:click.prevent="refreshLogbokClasses()" color="danger" type="gradient" icon-pack="feather" icon="icon-rotate-cw" icon-after></vs-button>
        </div>
      </div>
                       
      <vs-popup  classContent="popup-example" :title="'Book '+createBooking.title" :active.sync="bookingPopupActive">
        <form data-vv-scope="addBookingForm">
          <div id="createBookingLoadingDiv" class="vs-con-loading__container">
          Choose a Teacher
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <v-select v-validate="'required'" name="teacher" ref="teacher" v-model="createBooking.teacher" :options="teachersData" label="title">
                <template slot="option" slot-scope="option">
                    <img :src="option.image" width="20px" />
                    <span style="line-height: 20px;"> {{ option.title }}</span>
                </template>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('addBookingForm.teacher')">{{ errors.first('addBookingForm.teacher') }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              Date
              <datepicker v-validate="'required'" name="date" ref="date" format="yyyy-MM-dd" placeholder="Select a Date" v-model="createBooking.date"></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('addBookingForm.date')">{{ errors.first('addBookingForm.date') }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              Time
              <flat-pickr style="width: 100%;" :config="configdateTimePicker" v-model="createBooking.time" placeholder="Choose time" />
              <span class="text-danger text-sm" v-show="errors.has('time')">{{ errors.first('time') }}</span>
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" label="Student" v-model="createBooking.studentName" />
            </div>
          </div>

          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-input disabled class="w-full" label="Module" v-model="createBooking.title" />
            </div>
          </div>

          <div class="vx-row">
            <div align="right" class="vx-col w-full">
              <vs-button color="warning" type="border" class="mr-3 mb-2" @click="createBooking.teacher = createBooking.date = '';">Reset</vs-button>
              <vs-button v-on:click.prevent="validateBookingForm()" class="mr-3 mb-2">Book Class</vs-button>
            </div>
          </div>
        </div>
        </form>
      </vs-popup>

      <vs-popup classContent="popup-example" :title="editBooking.title" :active.sync="bookingEditPopupActive">
        <form data-vv-scope="editBookingForm">
        <div id="editBookingLoadingDiv" class="vs-con-loading__container">

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              Teacher
              <v-select @input="editAClassChangeTeacher()" v-validate="'required'" name="teacher" ref="teacher" v-model="editBooking.teacher" :options="teachersData" label="title">
                <template slot="option" slot-scope="option">
                    <img :src="option.image" width="20px" />
                    <span style="line-height: 20px;"> {{ option.title }}</span>
                </template>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('editBookingForm.teacher')">{{ errors.first('editBookingForm.teacher') }}</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <label>Teacher Sign</label>
              <vs-switch color="success" v-model="editBooking.teacher_sign" />
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              Student Sign Date
              <datepicker v-validate="'required'" name="date" ref="date" format="yyyy-MM-dd" placeholder="Select a Date" v-model="editBooking.date"></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('editBookingForm.date')">{{ errors.first('editBookingForm.date') }}</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              Teacher Sign Date
              <datepicker :disabled="!editBooking.teacher_sign" v-validate="editBooking.teacher_sign ?'required' : ''" name="signed_date_" ref="signed_date_" format="yyyy-MM-dd" placeholder="Select a Date" v-model="editBooking.signed_date_"></datepicker>
              <span class="text-danger text-sm" v-show="errors.has('editBookingForm.signed_date_')">{{ errors.first('editBookingForm.signed_date_') }}</span>
            </div>
          </div>

          <div class="vx-row mb-base">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              Student Sign Time
              <flat-pickr style="width: 100%;" :config="configdateTimePicker" v-model="editBooking.time" placeholder="Choose time" />
              <span class="text-danger text-sm" v-show="errors.has('time')">{{ errors.first('time') }}</span>
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              Teacher Sign Time
              <flat-pickr  :disabled="!editBooking.teacher_sign" style="width: 100%;" :config="configdateTimePicker" v-model="editBooking.signed_time" placeholder="Choose time" />
              <span class="text-danger text-sm" v-show="errors.has('date')">{{ errors.first('date') }}</span>
            </div>
          </div>

          <div class="vx-row mb-base">
            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input disabled class="w-full" label="Student" v-model="editBooking.studentName" />
            </div>

            <div class="vx-col sm:w-1/2 w-full mb-2">
              <vs-input disabled class="w-full" label="Module" v-model="editBooking.title" />
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row items-center justify-center" v-for="(feedback, feedbackIndex) in editBooking.teacher_feedbacks" :key="feedbackIndex">
            <div class="vx-col w-full" v-if="feedback.answer_type == 'text'">
              {{feedback.question}}
              <vs-textarea v-model="feedback.answer" />
            </div>
            <div class="vx-col w-full" v-else-if="feedback.answer_type == 'emoji'">
              {{feedback.question}}
              <div  class="vx-row ml-1">
                <p @click="addFeedback(feedbackIndex, 1)" class="mx-base selectableEmoji" :style="feedback.answer == 1 ? 'background: #0052a1;' :' background: white;'">&#128528;</p>
                <p @click="addFeedback(feedbackIndex, 2)" class="mx-base selectableEmoji" :style="feedback.answer == 2 ? 'background: #0052a1;' :' background: white;'">&#128578;</p>
                <p @click="addFeedback(feedbackIndex, 3)" class="mx-base selectableEmoji" :style="feedback.answer == 3 ? 'background: #0052a1;' :' background: white;'">&#128512;</p>
                <p @click="addFeedback(feedbackIndex, 4)" class="mx-base selectableEmoji" :style="feedback.answer == 4 ? 'background: #0052a1;' :' background: white;'">&#129321;</p>
              </div>
            </div>

            <vs-divider/>
          </div>

          <div align="right" class="vx-row mt-base">
            <div class="vx-col w-full">
              <vs-button color="danger" v-on:click.prevent="cancelClassConfirm()" class="mr-3 mb-2">Cancel Class</vs-button>
              <vs-button v-on:click.prevent="validateEditBookingForm()" class="mr-3 mb-2">Update Class</vs-button>
            </div>
          </div>
        </div>
        </form>
      </vs-popup>

      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-list>
            <vs-list-header title="Classes" color="primary"></vs-list-header>
              <div v-if="currentLogbokClass.non_booked_modules">
                <vs-list-item v-for="(listItem, index) in currentLogbokClass.non_booked_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                  <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  <vs-button @click="bookAClass(listItem)" radius color="primary" type="gradient" icon-pack="feather" icon="icon-plus"></vs-button>
                </vs-list-item>
              </div> 
          </vs-list>
        </div>

        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-list>
            <vs-list-header title="Booked / Rebookable Classes" color="primary"></vs-list-header>
              <div v-if="currentLogbokClass.student_signed_modules">
                <vs-list-item v-for="(listItem, index) in currentLogbokClass.student_signed_modules" :key="index" :title="listItem.name" :subtitle="getDateString(listItem.date)">
                  <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  <vs-button @click="editAClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-edit"></vs-button>
                </vs-list-item>
              </div>
              <div v-if="currentLogbokClass.teacher_signed_rebooked_modules">
                <vs-list-item v-for="(listItem, index) in currentLogbokClass.teacher_signed_rebooked_modules" :key="index" :title="listItem.name" :subtitle="getDateString(listItem.date)">
                  <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  <vs-button @click="editAClass(listItem)" radius color="danger" type="gradient" icon-pack="feather" icon="icon-edit"></vs-button>
                </vs-list-item>
              </div>
              <div v-if="currentLogbokClass.teacher_signed_unique_modules">
                <vs-list-item v-for="(listItem, index) in currentLogbokClass.teacher_signed_unique_modules" :key="index" :title="listItem.name" :subtitle="listItem.hours+' Min'">
                  <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  <vs-button @click="bookAClass(listItem)" radius color="success" type="gradient" icon-pack="feather" icon="icon-plus"></vs-button>
                </vs-list-item>
              </div> 
          </vs-list>
        </div>

        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-list>
            <vs-list-header title="Completed Classes" color="primary"></vs-list-header>
              <div v-if="currentLogbokClass.teacher_signed_modules">
                <div class="vs-list--item" v-for="(listItem, index) in currentLogbokClass.teacher_signed_modules" :key="index">
                  <div class="vs-list--avatar">
                    <vs-avatar slot="avatar" :src="listItem.module_logo" :text="listItem.name" />
                  </div>
                  <div class="list-titles">
                    <div class="vs-list--title">{{listItem.name}}</div>
                    <div class="vs-list--subtitle">{{ getDateString(listItem.date)+' > '+getDateString(listItem.signed_date_) }}</div>
                    <div  class="vx-row ml-1">
                      <p style="font-size: 24px;" v-for="(feedback, feedbackIndex) in listItem.teacher_feedbacks" :key="feedbackIndex" v-html="getEmojiWithId(feedback.answer)"></p>
                    </div>
                  </div>
                  <div class="vs-list--slot">
                    <vs-button @click="editAClass(listItem)" radius color="success" type="gradient" icon-pack="feather" icon="icon-edit"></vs-button>
                  </div>
                </div>
              </div> 
          </vs-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleClassManagement from '@/store/class-management/moduleClassManagement.js'

export default {
  components: {
    vSelect,
    flatPickr,
    Datepicker,
    VuePerfectScrollbar,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    logbok_class: {
      // type: Array,
      required: true,
    },
  },
  data() {
    return {
      active1: true,
      bookingPopupActive : false,
      bookingEditPopupActive : false,
      selectedTeacher : {},
      data_local: JSON.parse(JSON.stringify(this.data)),
      // currentLogbokClass: JSON.parse(JSON.stringify(this.logbok_class)),
      // currentLogbokClass: this.logbok_class,
      currentLogbokClass: JSON.parse(JSON.stringify(this.logbok_class)),

      createBooking : {
        title : null,
        date : null,
        studentName : null,
        packageName : null,
        packageId : null,
        moduleId : null,
        teacher : null,
      },
      editBooking : {
        test_data : null,
        title : null,
        booked_date : null,
        booked_id: null,
        booked_time: null,
        date: null,
        time: null,
        name: null,
        package_id: null,
        signed_date_: null,
        signed_date: null,
        signed_descrition: null,
        signed_time: null,
        student_sign: null,
        student_signed_actual_time: null,
        teacher_data: null,
        teacher_sign: false,
        teacher_signed_actual_time: null,
        studentName : null,
        packageName : null,
        packageId : null,
        moduleId : null,
        teacher : {
          id : null,
          image : null,
          title : null,
        },
        teacher_ : {
          id : null,
          image : null,
          title : null,
        },
        teacher_feedbacks : [],
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true,
        dateFormat: 'H:i',
      },
      showCreateBookingError : true,

      langOptions: [
        { label: "English",  value: "english"  },
        { label: "Spanish",  value: "spanish"  },
        { label: "French",   value: "french"   },
        { label: "Russian",  value: "russian"  },
        { label: "German",   value: "german"   },
        { label: "Arabic",   value: "arabic"   },
        { label: "Sanskrit", value: "sanskrit" },
      ],

      time_config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'H:i',
        // locale: Hindi, // locale for this instance only          
      },   
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    },
    teachersData() {
      let teachers = this.$store.state.userManagement.teachers
      let teachersData = []

      teachers.forEach(function(entry, key) {
        teachersData.push({
          id : entry.id,
          image : entry.image,
          title : entry.name+" "+entry.last_name,
        })
      });

      return teachersData
    },
  },
  methods: {
    addFeedback(index, answer){
      this.editBooking.teacher_feedbacks[index].answer = answer;
      this.$forceUpdate()

    },
    getEmojiWithId(id){
      if(id == 1) return "&#128528;"
      else if(id == 2) return "&#128578;"
      else if(id == 3) return "&#128512;"
      else if(id == 4) return "&#129321;"
      return "";
    },
    cancelClassConfirm() {
      this.bookingEditPopupActive = false
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure to cancel this class ?',
        accept: this.cancelClass,
        cancel: this.stopCancelClass,
      })
    },
    cancelClass() {
      this.bookingEditPopupActive = true
      this.$vs.loading()

      var bookingData = {
        cancel_by : 'me',
        student_id : this.data_local.id,
        log_book_booking_id : this.editBooking.booked_id,
      }

      this.$store.dispatch("classManagement/cancelLogBokClass", bookingData)
        .then(res => { 
          this.$vs.loading.close()
          if(res.status == 201){
            this.bookingEditPopupActive = false

            this.$vs.notify({
                title: "Success.",
                text: "Class cancelled successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.fetchUserLogbokClass(bookingData.student_id)
          }
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    stopCancelClass() {
      this.bookingEditPopupActive = true
    },
    refreshLogbokClasses() {
      this.$vs.loading({
          container: '#studentLogbokClassLoadingDiv',
          scale: 0.6
      })

      this.fetchUserLogbokClass(this.data_local.id)
    },
    validateEditBookingForm() {
      this.$validator.validateAll('editBookingForm').then(result => {
        if (result) this.editAClassFun()
        else{
          
        }
      })
    },
    validateBookingForm() {
      this.$validator.validateAll('addBookingForm').then(result => {
        if (result) this.bookAClassFun()
        else{
          
        }
      })
    },
    bookAClassFun() {
      this.$vs.loading({
          container: '#createBookingLoadingDiv',
          scale: 0.6
      })

      var bookingData = {
        student_id : this.data_local.id,
        teacher_id : this.createBooking.teacher.id,
        package_id : this.createBooking.packageId,
        module_id : this.createBooking.moduleId,
        time : this.createBooking.time,
        date : this.getDateString(this.createBooking.date),
      }

      this.$store.dispatch("classManagement/bookLogBokClass", bookingData)
        .then(res => { 
          if(res.status == 201){
            this.$vs.notify({
                title: "Success.",
                text: "Class booked successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.bookingPopupActive = false
            this.fetchUserLogbokClass(bookingData.student_id)
          }
          else if(res.status == 200){
            this.showCreateBookingError = true
            this.$vs.notify({
              time:4000,
              title:'',
              text: (res.data.error.message) ? res.data.error.message : 'Error in booking.',
              color:'danger',
              iconPack: 'feather',
              icon:'icon-alert-circle'
            });
          }

          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })
        .catch(err => { 
          this.$vs.loading.close('#createBookingLoadingDiv > .con-vs-loading')
        })
    },
    editAClassFun() {
      this.$vs.loading()

      var bookingData = {
        log_book_booking_id : this.editBooking.booked_id,
        student_id : this.data_local.id,
        teacher_id : this.editBooking.teacher.id,
        package_id : this.editBooking.package_id,
        module_id : this.editBooking.id,
        date : this.getDateString(this.editBooking.date),
        time : (this.editBooking.time == '') ? null : this.editBooking.time,
        teacher_sign : this.editBooking.teacher_sign,
        attendance : 'Present',
        result : 'pass',
        signed_date : this.getDateString(this.editBooking.signed_date_),
        signed_time : this.editBooking.signed_time,
        signed_descrition : this.editBooking.signed_descrition,
        teacher_feedbacks : this.editBooking.teacher_feedbacks,
      }

      this.$store.dispatch("classManagement/editLogBokClass", bookingData)
        .then(res => { 
          this.$vs.loading.close()
          if(res.status == 201){
            this.$vs.notify({
                title: "Success.",
                text: "Class updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });

            this.fetchUserLogbokClass(bookingData.student_id)
          }
        })
        .catch(err => { 
          this.$vs.loading.close()
        })
    },
    fetchUserLogbokClass(userId) {
      this.$store.dispatch("userManagement/fetchStudentLogbokClasses", userId)
        .then(res => { 
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
          this.currentLogbokClass = res.data
          // this.$emit('logbok_class', this.logbok_class)
        })
        .catch(err => {
          this.$vs.loading.close('#studentLogbokClassLoadingDiv > .con-vs-loading')
          // console.error(err) 
        })
    },
    getDateString(date) {
      const d = new Date(date);
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
      const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
      return (`${ye}-${mo}-${da}`);
    },
    bookAClass(classItem) {
      this.bookingPopupActive = true
      this.createBooking.title = classItem.name
      this.createBooking.moduleId = classItem.id
      this.createBooking.packageId = classItem.package_id
      this.createBooking.studentName = this.data_local.name+" "+this.data_local.last_name
    },
    editAClass(classItem) {
      this.bookingEditPopupActive = true
      this.editBooking = classItem
      this.editBooking.title = classItem.name
      this.editBooking.teacher_sign = (classItem.teacher_sign == '1') ? true : false
      this.editBooking.studentName = this.data_local.name+" "+this.data_local.last_name
      this.editBooking.teacher_feedbacks = classItem.teacher_feedbacks

      if(this.teachersData.length && classItem.teacher_data.id){
        let filterTeacherData = this.teachersData.filter(function (entry) {
          return entry.id == classItem.teacher_data.id;
        });

        if(filterTeacherData.length > 0) this.editBooking.teacher = filterTeacherData[0]
        // if(filterTeacherData.length > 0) this.editBooking.teacher = Object.assign({}, filterTeacherData[0])
      }
    },
    editAClassChangeTeacher() {
      let newSelectedTeacher = this.editBooking.teacher
      let newSelectedTeacherSign = this.editBooking.teacher_sign
      this.editBooking.teacher_sign = !newSelectedTeacherSign
      this.editBooking.teacher = newSelectedTeacher
      this.editBooking.teacher_sign = newSelectedTeacherSign
    },
    save_changes() {
      if(!this.validateForm)return
    
    },
    reset_data() {
      this.data_local = Object.assign({}, this.data)
    }
  },
  created() {
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }

    if(!moduleClassManagement.isRegistered) {
      this.$store.registerModule('classManagement', moduleClassManagement)
      moduleClassManagement.isRegistered = true
    }


    this.$store.dispatch("userManagement/fetchTeachers").catch(err => { console.error(err) })
  },
  mounted(){
    this.refreshLogbokClasses()
  }
}
</script>

<style type="text/css">
  
.vdp-datepicker .vdp-datepicker__calendar {
    z-index: 60000 !important;
    /*position: relative;*/
    width: 270px;
    border-radius: 5px !important;
}


p.selectableEmoji{
    font-size: 50px;
    border-radius: 5px;
    cursor: pointer !important;
}
</style>